import { useQuery } from '@tanstack/react-query';
import { useContainer } from 'src/features/ioc';
import { useAccessToken } from 'src/hooks/state';
import {
    getRandomSymbolsQuery,
    getSecurityMasterAccessKeyQuery,
    getSecurityMasterEntriesQuery,
    getSecurityMasterEntryQuery,
    getSymbolsMatchingPrefixQuery,
} from 'src/queries/securityMaster';

export function useSecurityMasterAccessKey() {
    const accessToken = useAccessToken();
    const container = useContainer();

    const queryClient = container.get('QueryClient');
    const securityMasterService = container.get('SecurityMasterService');

    const { data } = useQuery(getSecurityMasterAccessKeyQuery(accessToken, queryClient, securityMasterService));

    return data;
}

export function useSecurityMasterEntry(symbol?: string) {
    const securityMasterAccessKey = useSecurityMasterAccessKey();
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    return useQuery(getSecurityMasterEntryQuery(securityMasterAccessKey, securityMasterService, symbol));
}

export function useSecurityMasterEntries(symbols: string[]) {
    const securityMasterAccessKey = useSecurityMasterAccessKey();
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    // todo: https://github.com/yornaath/batshit?tab=readme-ov-file#reactquery-example
    return useQuery(getSecurityMasterEntriesQuery(securityMasterAccessKey, securityMasterService, symbols));
}

export function useGetSymbolsMatchingPrefix(prefix: string) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    const securityMasterAccessKey = useSecurityMasterAccessKey();

    return useQuery(getSymbolsMatchingPrefixQuery(securityMasterAccessKey, securityMasterService, prefix));
}

export function useSymbolEntriesMatchingPrefix(prefix: string) {
    const { data: matchingSymbols = [] } = useGetSymbolsMatchingPrefix(prefix);

    return useSecurityMasterEntries(matchingSymbols);
}

export function useGetRandomSymbols(count: number) {
    const container = useContainer();
    const securityMasterService = container.get('SecurityMasterService');

    const securityMasterAccessKey = useSecurityMasterAccessKey();

    return useQuery(getRandomSymbolsQuery(securityMasterAccessKey, securityMasterService, count));
}
